module.exports = __webpack_public_path__ + "img/caret-down-solid.b1c00904.svg";